import { Tabs, Tab } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import {
  mediaGalleryTabClassNames,
  mediaGalleryTabListClassNames,
  MediaGalleryTimelineContainer,
  MediaGalleryTimelineTabList,
} from './MediaGalleryTimeline.styled';
import { MediaGalleryTimelineLabel } from './subcomponents/MediaGalleryTimelineLabel';
import { useMediaGalleryLightBoxContext } from '../../contexts/MediaGalleryLightBoxContext/MediaGalleryLightBoxContext';

export interface MediaGalleryTimeline {
  year: string;
  indexTo: number;
  indexFrom: number;
}

export const MediaGalleryTimeline: FunctionComponent<{
  timelines: ReadonlyArray<MediaGalleryTimeline>;
}> = ({ timelines }) => {
  const { setCurrentSlideByIndex, currentSlideIndex } = useMediaGalleryLightBoxContext();
  const activeTimeline = timelines.find(
    ({ indexFrom, indexTo }) => currentSlideIndex >= indexFrom && currentSlideIndex <= indexTo,
  );
  const tabPanelAccessibleId = `tabpanel-${currentSlideIndex}`;
  const tabCount = timelines.length;
  let currentTimelineIndex: number | undefined = timelines.findIndex(
    ({ year }) => year === activeTimeline?.year,
  );
  if (currentTimelineIndex < 0) currentTimelineIndex = undefined;

  return (
    <MediaGalleryTimelineContainer>
      <Tabs
        selectedTab={currentTimelineIndex}
        variant="full-width"
        underlineColor={currentTimelineIndex === undefined ? 'transparent' : 'borderInverted'}
      >
        <MediaGalleryTimelineTabList
          buttonColor="black"
          dangerouslySetClassNames={mediaGalleryTabListClassNames}
          $tabCount={tabCount}
        >
          {timelines.map((timeline) => {
            const { year, indexFrom } = timeline;
            const onCLickHandler = () => setCurrentSlideByIndex(indexFrom, false);
            const isSelected = year === activeTimeline?.year;
            return (
              <Tab
                key={year}
                aria-selected={isSelected}
                aria-controls={tabPanelAccessibleId}
                dangerouslySetClassNames={mediaGalleryTabClassNames}
                tabIndex={0}
                onClick={onCLickHandler}
              >
                <MediaGalleryTimelineLabel $isSelected={isSelected}>
                  {year}
                </MediaGalleryTimelineLabel>
              </Tab>
            );
          })}
        </MediaGalleryTimelineTabList>
      </Tabs>
    </MediaGalleryTimelineContainer>
  );
};
